import {
    Component,
    Input,
    ViewChild,
    ElementRef,
    Output,
    EventEmitter
} from '@angular/core';
import { TranslationService } from '../../translations';

@Component({
    selector: 'copy-button',
    host: {
        class: ''
    },
    template: `
        <input
            #textBox
            type="text"
            readonly
            class="form-control input-sm"
            style="margin-right: 10px; min-width: 100px;"
            [value]="displayName"
            data-testing="copyButton"
        />
        <button
            (click)="onClick($event)"
            class="button button-sm button-secondary button-icon"
        >
            <span class="fa fa-copy before"></span>
            {{ TR.key('Copy') }}
        </button>
    `,
    standalone: false
})
export class CopyButtonComponent {
    @ViewChild('textBox', { static: false })
    textBox: ElementRef;
    @Input()
    displayName: string;

    @Output()
    buttonClicked = new EventEmitter();

    showCopyMessage = false;
    private timeOut: number;

    constructor(public TR: TranslationService) {}

    onClick(event: Event) {
        this.showCopyMessage = true;
        this.textBox.nativeElement.select();
        document.execCommand('copy');
        document.getSelection().removeAllRanges();
        if (this.timeOut) {
            clearTimeout(this.timeOut);
        }
        this.timeOut = window.setTimeout(
            () => (this.showCopyMessage = false),
            1500
        );
        event.stopPropagation();
        event.preventDefault();
        this.buttonClicked.emit('$event');
    }
}
